export { TooltipContainerComponent } from './tooltip-container.component';
export { TooltipDirective } from './tooltip.directive';
export { TooltipModule } from './tooltip.module';
export { TooltipConfig } from './tooltip.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/tooltip/index.js
// module id = 680
// module chunks = 7